//business companion

export const dispalyImages = [
    "https://tmetric.com/media/e5enfaae/img-advantages.png",
    "https://tmetric.com/media/d2dhexfq/img-advantages-project-management.png",
    "https://tmetric.com/media/b3abexjt/img-advantages-team-management.png",
    "https://tmetric.com/media/nmmhl5l3/img-advantages-invoice.png",
    "https://tmetric.com/media/bpli5hts/img-advantages-reporting.png",
    "https://tmetric.com/media/kuqjgrfl/img-advantages-time-off.png",
]

export const iconImages =[
    "https://tmetric.com/media/2p4n4oyc/icon-timer-blue.svg",
    "https://tmetric.com/media/1niddz51/icon-project-blue.svg",
    "https://tmetric.com/media/2gxihhdu/icon-team-blue.svg",
    "https://tmetric.com/media/s4koycnp/icon-invoice-blue.svg",
    "https://tmetric.com/media/yoblhiut/icon-reports-blue.svg",
    "https://tmetric.com/media/cajpa4uy/icon-time-off-blue.svg",
]

export const iconImagesGray =[
    "https://tmetric.com/media/qojb5snq/icon-timer-gray.svg",
    "https://tmetric.com/media/kqgpqtvh/icon-project-gray.svg",
    "https://tmetric.com/media/isxcp2ip/icon-team-gray.svg",
    "https://tmetric.com/media/5r1l1s4g/icon-invoice-gray.svg",
    "https://tmetric.com/media/g3jc0dsg/icon-reports-gray.svg",
    "https://tmetric.com/media/bxylkc2s/icon-time-off-gray.svg",
]



export const innerText =[
    "Capture every task you work on. Take control over time intervals by simple time tracking",
    "Create projects, set rates and budgets. Keep tracking of hours spent on tasks and see the project progress at a glance, collaborate easily, keep deadlines and prevent over budgeting",
    "Measure productivity and activity level of your team, assign tasks in a click, monitor workflow and distribute the workload. Syncs your teams’ work and improves efficiency.",
    "With the accurate billing system, set billable rates and easily create an invoice based on tracked time and expenses, and get paid promptly.",
    "With a flexible reporting system, you have a choice to get insights into your projects and team productivity, analyze incomes and keep costs under control",
    "Add a PTO policy for your organization, simply ask for days off, control missed workdays, manage balances and teams attendance hassle-free",
]

export const headText =[
    "Time Tracking",
    "Project Management",
    "Team Management",
    "Billing & Invoicing",
    "Reporting",
    "Time Off"
]

//manageTeamData

export const manageTeamData = [
    "https://tmetric.com/media/upkh02nn/img-activity-cases.svg",
    "https://tmetric.com/media/hx0j4hno/img-report-cases-svg.svg",
    "https://tmetric.com/media/0sapzfi1/time-off-calendar-case.png",
]

export const manageTeamDataHeading = [
    "Manage your team effectively",
    "Ensure the profitability of your business",
    "Monitor attendance and time-off requests",
]

export const manageTeamDataListOne = [
    "timekeeping",
    "sites and apps monitoring",
    "activity tracking",
    "screenshots capturing",
    "task management",
    "50+ integrations",
    "work schedule"
]

export const manageTeamDataListTwo = [
    "timekeeping",
    "sites and apps monitoring",
    "activity tracking",
    "screenshots capturing",
    "task management",
    "50+ integrations",
    "work schedule"
]

export const manageTeamDataListThree = [
    "timekeeping",
    "sites and apps monitoring",
    "activity tracking",
    "screenshots capturing",
    "task management",
    "50+ integrations",
    "work schedule"
]

// popular services data

export const popularServicesImages = [
    "https://tmetric.com/media/cshbmvwf/logo-integration-gsuite.svg",
    "https://tmetric.com/media/fnbggshs/logo-integration-msoffice.svg",
    "https://tmetric.com/media/plvb1mg0/logo-integration-gkeep.svg",
    "https://tmetric.com/media/smflyk5w/logo-integration-github.svg",
    "https://tmetric.com/media/kbrcntmi/logo-integration-excel.svg",
    "https://tmetric.com/media/4aeci1fh/logo-integration-asana.svg",
    "https://tmetric.com/media/caxbzjss/logo-integration-jira.svg",
    "https://tmetric.com/media/dw2nwjwv/logo-integration-gitlab.svg",
    "https://tmetric.com/media/me5ih5eu/logo-integration-gdocs.svg",
    "https://tmetric.com/media/0bzmfrlf/logo-integration-trello.svg",
    "https://tmetric.com/media/sdaj41fi/logo-integration-redmine.svg",
    "https://tmetric.com/media/1xedbfav/logo-integration-zendesk.svg",
    "https://tmetric.com/media/n3dmgi1p/logo-integration-wrike.svg",
]

// tabs data 

export const tabsData = [
    "Software developers",
    "Marketers",
    "Designers",
    "Contractors",
    "Consultants",
    "Freelancers"
]

export const tabsDataImages = [
    "https://tmetric.com/media/hznb1sgs/photo-software-developers.png",
    "https://tmetric.com/media/dhbotvr1/photo-marketers.png",
    "https://tmetric.com/media/bxyho4oy/photo-designers.png",
    "https://tmetric.com/media/2pdfttnr/photo-contractors.png",
    "https://tmetric.com/media/ipkhp5ts/photo-consulting.png",
    "https://tmetric.com/media/1nlgnvyj/photo-freelance.png"
]

export const tabsDataInner = [
    "We ultimately went with TMetric because it checked a lot of items on our want list. It’s both a desktop and web app, and has an API that we were able to integrate with our business management software. While that was the biggest selling point, we also really like the user interface, the Chrome extension, and built-in integration with Jira.",
    "We’ve found TMetric to be both user friendly and robust. It was easy to setup which allowed us to begin leveraging the tool immediately. It also provides multiple layers of reporting which provides value to our organization on a number of different levels.",
    "TMetric is faster, more convenient and cheaper, the support is responsive and they fixed some bugs quickly.",
    "I recently transitioned from full-time employee to ‘consultant’. Needed an app to track projects, tasks and generate billing based on our agreement. TMetric handles this elegantly and I can access from my iPhone, iPad or PC- awesome!",
    "After five months we are very happy with the app and will gladly renew the service. We are still finding new uses for it within our organization and it’s been pivotal for helping us gather better decision-making information, grow our topline and reduce our bottomline",
    "There are plenty of available applications to monitor working time. We chose TMetric because of the suitable price and compatibility with Trello and Google Documents, which we use every day in our company."
]
export const tabsDataInnerHeading = [
    "BizStream team",
    "Brian Reilly, BankBound",
    "Swen Roethlisberger, Floowedit",
    "Jim Rolph, Manufacturer's Representative at Gorman Company",
    "Galeno Chua, The Idea Founding Principal",
    "Patryk Hoffmann, MyLead",   
]

// whyTmetric data

export const whyTmetricImage =[
    "https://tmetric.com/media/zrvmvbl3/icon-straightforward.svg",
    "https://tmetric.com/media/opdfdo3l/icon-platforms.svg",
    "https://tmetric.com/media/igkmpmix/icon-freetrial.svg",
    "https://tmetric.com/media/htxfmpoe/icon-reasonableprice.svg",
    "https://tmetric.com/media/0uyowzzu/icon-multilang.svg",
]

export const whyTmetricText =[
    "The most straightforward time tracking app",
    "Available on all platforms: macOS, Windows, Linux, iOS, and Android",
    "Free plan with basic time tracking for a team up to 5",
    "Reasonable price makes it affordable for anyone",
    "Multilanguage solution",
]

